import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "map-wr" }
const _hoisted_2 = { class: "dashboard-header" }
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = {
  key: 0,
  class: "card map-info"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row-item" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "row-item" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "row-item" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "row-item" }
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "row-item clip" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "row-item clip" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = {
  key: 0,
  class: "row"
}
const _hoisted_22 = { class: "row-item" }
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "row-item" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = {
  key: 1,
  class: "row"
}
const _hoisted_27 = { class: "row-item" }
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "row-item" }
const _hoisted_30 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "title-main" }, "Map", -1)),
      _createElementVNode("div", _hoisted_3, [
        (!$setup.map)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button default primary add-btn-primary",
              onClick: $setup.toCreateMap
            }, "Add Map"))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("button", {
                class: "button default outlined",
                onClick: $setup.toEditMap
              }, "Edit Map"),
              _createElementVNode("button", {
                class: "button default outlined warning",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showConfirmDeleteModal = true))
              }, "Delete Map")
            ], 64))
      ]),
      _createVNode($setup["ConfirmDeleteModal"], {
        isOpen: $setup.showConfirmDeleteModal,
        deleteItem: 'lot map',
        onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showConfirmDeleteModal = false)),
        onConfirm: $setup.deleteMap
      }, null, 8, ["isOpen"])
    ]),
    ($setup.map)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createTextVNode("Width: ", -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString($setup.map.size.width), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[4] || (_cache[4] = _createTextVNode("Height: ", -1)),
              _createElementVNode("span", _hoisted_9, _toDisplayString($setup.map.size.height), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[5] || (_cache[5] = _createTextVNode("Coordinate X: ", -1)),
              _createElementVNode("span", _hoisted_12, _toDisplayString($setup.map.binding.x), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[6] || (_cache[6] = _createTextVNode("Coordinate Y: ", -1)),
              _createElementVNode("span", _hoisted_14, _toDisplayString($setup.map.binding.y), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[7] || (_cache[7] = _createTextVNode("Figure Path: ", -1)),
              _createElementVNode("span", _hoisted_17, _toDisplayString($setup.map.path), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _cache[8] || (_cache[8] = _createTextVNode("Status Figure Path: ", -1)),
              _createElementVNode("span", _hoisted_20, _toDisplayString($setup.map.statusPath), 1)
            ])
          ]),
          ($setup.map.houseMarker)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _cache[9] || (_cache[9] = _createTextVNode("House X: ", -1)),
                  _createElementVNode("span", _hoisted_23, _toDisplayString($setup.map.houseMarker.x), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[10] || (_cache[10] = _createTextVNode("House Y: ", -1)),
                  _createElementVNode("span", _hoisted_25, _toDisplayString($setup.map.houseMarker.y), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.map.houseMarker)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _cache[11] || (_cache[11] = _createTextVNode("House Width: ", -1)),
                  _createElementVNode("span", _hoisted_28, _toDisplayString($setup.map.houseMarker.width), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[12] || (_cache[12] = _createTextVNode("House Height: ", -1)),
                  _createElementVNode("span", _hoisted_30, _toDisplayString($setup.map.houseMarker.height), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}